import { getMetricFromRoofLevels as o } from "../index7.js";
import { getLevelNetFacadeArea as r } from "../level-metrics/index24.js";
const m = (e) => o(e, r);
export {
  m as getRoofNetFacadeArea
};
//# sourceMappingURL=index52.js.map
